/**
 * <s-variant-media media-id="..."> — rendered inside the product-form partial.
 * When a variant change re-renders the partial, switch the product carousel
 * (<s-product-gallery>) to that variant's own image, in place. The page itself
 * never scrolls. A variant without an assigned image renders an empty media-id,
 * so the current image stays. The first render on page load does nothing; the
 * gallery handles a ?variant= image itself via data-initial-media-id.
 */
let initialRender = true;

class VariantMedia extends HTMLElement {
  connectedCallback() {
    if (initialRender) {
      initialRender = false;
      return;
    }
    const mediaId = this.getAttribute('media-id');
    if (!mediaId) return;
    const gallery = document.querySelector('s-product-gallery');
    if (gallery && typeof gallery.showMedia === 'function') gallery.showMedia(mediaId);
  }
}

if (!customElements.get('s-variant-media')) customElements.define('s-variant-media', VariantMedia);
